<template>
  <div v-loading="loading" class="nx-page meterenergy-analysis">
    <el-card shadow="never">
      <div slot="header" class="card-head">
        <span>能耗对比分析（抄表）</span>
        <div class="filters">
          <el-date-picker v-model="billingMonth" type="month" value-format="yyyyMM" clearable size="small" style="width: 150px" />
          <el-button type="primary" size="small" @click="load">查询</el-button>
        </div>
      </div>
      <el-row :gutter="16">
        <el-col :md="12" :xs="24">
          <div class="chart-title">费目结构雷达（归一化）</div>
          <div ref="chartRadar" class="chart-box" />
        </el-col>
        <el-col :md="12" :xs="24">
          <div class="chart-title">电类目 TOP（kWh）</div>
          <div ref="chartBar" class="chart-box" />
        </el-col>
      </el-row>
      <div class="chart-title mt16">暖 · 近 6 月</div>
      <div ref="chartHeat" class="chart-box" />
      <div class="chart-title mt16">污水 · 近 6 月</div>
      <div ref="chartSew" class="chart-box" />
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { fetchEnergyCompare } from './api'

export default {
  name: 'MeterEnergyCompare',
  data() {
    return { loading: false, billingMonth: null, data: {}, charts: [] }
  },
  mounted() {
    this.load()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    this.charts.forEach((c) => c.dispose())
  },
  methods: {
    resize() {
      this.charts.forEach((c) => c.resize())
    },
    async load() {
      this.loading = true
      try {
        const res = await fetchEnergyCompare({ billingMonth: this.billingMonth || undefined })
        this.data = (res.data && res.data.data) || {}
        this.$nextTick(() => this.renderCharts())
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    renderCharts() {
      this.charts.forEach((c) => c.dispose())
      this.charts = []
      const d = this.data
      const radar = echarts.init(this.$refs.chartRadar)
      const rc = d.radarCurrent || [0, 0, 0, 0]
      const rp = d.radarPrevious || [0, 0, 0, 0]
      radar.setOption({
        tooltip: {},
        legend: { data: ['本月', '上月'], bottom: 0 },
        radar: {
          indicator: [
            { name: '电', max: 100 },
            { name: '水', max: 100 },
            { name: '暖', max: 100 },
            { name: '污水', max: 100 }
          ]
        },
        series: [
          {
            type: 'radar',
            data: [
              { value: rc, name: '本月', areaStyle: { color: 'rgba(13,148,136,0.35)' } },
              { value: rp, name: '上月', areaStyle: { color: 'rgba(148,163,184,0.2)' }, lineStyle: { type: 'dashed' } }
            ]
          }
        ]
      })
      this.charts.push(radar)

      const tops = d.electricCategoryTop || []
      const sorted = [...tops].sort((a, b) => (Number(a.usageAmount) || 0) - (Number(b.usageAmount) || 0))
      const bar = echarts.init(this.$refs.chartBar)
      bar.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 100, right: 24, top: 16, bottom: 28 },
        xAxis: { type: 'value', name: 'kWh' },
        yAxis: { type: 'category', data: sorted.map((x) => x.category) },
        series: [{ type: 'bar', data: sorted.map((x) => Number(x.usageAmount) || 0), itemStyle: { color: '#059669' } }]
      })
      this.charts.push(bar)

      const heatM = d.heatMonthly || []
      const h = echarts.init(this.$refs.chartHeat)
      h.setOption(this.lineOpt(heatM, '#ef4444'))
      this.charts.push(h)

      const sewM = d.sewageMonthly || []
      const s = echarts.init(this.$refs.chartSew)
      s.setOption(this.lineOpt(sewM, '#64748b'))
      this.charts.push(s)
    },
    lineOpt(rows, color) {
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 48, right: 16, top: 16, bottom: 28 },
        xAxis: { type: 'category', data: rows.map((x) => x.billingMonth) },
        yAxis: { type: 'value' },
        series: [{ type: 'line', smooth: true, data: rows.map((x) => Number(x.usageAmount) || 0), lineStyle: { color, width: 2 } }]
      }
    }
  }
}
</script>

<style scoped>
.card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.filters {
  display: flex;
  gap: 8px;
  align-items: center;
}
.chart-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
.chart-box {
  height: 300px;
  width: 100%;
}
.mt16 {
  margin-top: 16px;
}
</style>
